import { action } from 'src/store/actions';

export const FETCH_ORDER_PRODUCTS_BY_ORDER_ID = 'FETCH_ORDER_PRODUCTS_BY_ORDER_ID';
export const REQUEST_ORDER_PRODUCTS_BY_ORDER_ID = 'REQUEST_ORDER_PRODUCTS_BY_ORDER_ID';
export const SUCCESS_ORDER_PRODUCTS_BY_ORDER_ID = 'SUCCESS_ORDER_PRODUCTS_BY_ORDER_ID';
export const FAILURE_ORDER_PRODUCTS_BY_ORDER_ID = 'FAILURE_ORDER_PRODUCTS_BY_ORDER_ID';

export const fetchOrderProducts = (orderId: string) => action(FETCH_ORDER_PRODUCTS_BY_ORDER_ID, { orderId });
export const requestOrderProducts = (orderId: string) => action(REQUEST_ORDER_PRODUCTS_BY_ORDER_ID, { orderId });
export const requestOrderProductsSuccess = (response: any) => action(SUCCESS_ORDER_PRODUCTS_BY_ORDER_ID, { response });
export const requestOrderProductsFailure = (error: any) => action(FAILURE_ORDER_PRODUCTS_BY_ORDER_ID, { error });
